import { trackSponsorClick } from "../lib/analytics";
import React, { useEffect, useState } from "react";
import { listSponsors } from "../lib/db";

function shuffle(array) {
  const arr = [...array];
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
  return arr;
}

export default function SponsorInlineOro() {
  const [sponsors, setSponsors] = useState([]);

  useEffect(() => {
    listSponsors()
      .then((data) => {
        const oroSponsors = data.filter((s) => s.tier === "oro");
        setSponsors(shuffle(oroSponsors));
      })
      .catch(console.error);
  }, []);

  if (sponsors.length === 0) return null;

  return (
    <div className="my-8 flex flex-col items-center">
      <span className="text-[10px] uppercase tracking-widest text-zinc-500 mb-3">Sponsor</span>
      <div className="flex flex-wrap justify-center gap-4">
        {sponsors.map((sponsor) => (
          <a
            key={sponsor.id}
            href={sponsor.website_url || "#"}
            target="_blank"
            rel="noopener noreferrer"
            title={sponsor.name}
            className="inline-block rounded-xl border border-zinc-800 bg-zinc-900 hover:border-yellow-400/50 transition-colors p-3"
            onClick={() => trackSponsorClick(sponsor.name, sponsor.tier)}
          >
            {sponsor.logo_url ? (
              <img
                src={sponsor.logo_url}
                alt={sponsor.name}
                className="h-20 w-auto max-w-[300px] object-contain"
              />
            ) : (
              <span className="font-display font-bold text-zinc-300 text-lg px-4">{sponsor.name}</span>
            )}
          </a>
        ))}
      </div>
    </div>
  );
}